import {Stack, Typography} from "@mui/material";
import React from "react";
import {formatCurrency, PayerModel} from "../../firebase/index.js";
import {expense_green_600, expense_red_600} from "../../reusables/js/APXTheme.js";


interface PayerDetailsRowProps {
	  item: PayerModel;
}


export default function PayerDetailsRow({item}: PayerDetailsRowProps) {
	  const payer: PayerModel = item;
	  return (
				 <Stack direction="row" spacing={2} justifyContent="space-evenly" alignItems="center" color={"#d9d9d9"}>
						<Typography sx={{flex: 1, textAlign: "center", fontSize: "10px"}}>{payer.name}</Typography>
						<Typography sx={{fontSize: "10px"}}>(Paying for: {payer.payingFor})</Typography>
						<Typography sx={{flex: 1, textAlign: "end", fontSize: "10px", color: expense_green_600}}>{formatCurrency(payer.paid)}</Typography>
						<Typography sx={{flex: 1, textAlign: "start", fontSize: "10px", color: payer.due <= 0 ? expense_green_600 : expense_red_600}}>{formatCurrency(payer.due)}</Typography>
				 </Stack>
	  );
}